<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $tc("unitofmeasurement", 2) }}
      </div>
      <div>
        <router-link
          v-if="$can('update', 'Unit of Measurements')"
          class="btn-blue"
          :to="'/master/edit-unit-of-measurment/?uom_id=' + uom_id"
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="/master/unit-of-measurment"
          >{{ $tc("unitofmeasurement", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("unitofmeasurement", 2) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ uom_unit }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("parent") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ fc_parent_label }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("description") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ uom_description }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("status", 1) }}
              </div>
              <div
                v-if="uom_is_active == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >
                {{ $t("active") }}
              </div>
              <div
                v-if="uom_is_active == 'N'"
                class="col-md-9 col-lg-10 col-xl-10"
              >
                {{ $t("-") }}
              </div>
            </div>
          </div>

          <div
            class="col-md-12 py-2 border-bottom"
            v-if="GetRoleId && GetRoleId === 1"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ created_by }}</span>

                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
              </div>
            </div>
          </div>

          <div
            class="col-md-12 py-2 border-bottom"
            v-if="GetRoleId && GetRoleId === 1"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ created_at | dateparse }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>

          <div
            class="col-md-12 py-2 border-bottom"
            v-if="GetRoleId && GetRoleId === 1"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
                <span>{{ updated_by }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2" v-if="GetRoleId && GetRoleId === 1">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ updated_at | dateparse }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
//import PosFnbService from "@/services/PosFnbService";
import { BASEURL } from "@/config/index.js";

export default {
  components: { Multiselect },
  data() {
    return {
      uom_unit: "",
      uom_short_form: "",
      uom_parent_id: 0,
      uom_formula: "",
      uom_description: "",
      uom_is_active: true,

      is_parent: false,
      uom_is_active: "",
      created_at: "",
      created_by: "",
      updated_by: "",
      updated_at: "",
      fc_parent_label: "",

      URL_BASE: BASEURL,
    };
  },
  beforeMount() {
    this.uom_id = this.$route.query.uom_id;
  },
  mounted() {
    this.getVendorsList();
  },
  methods: {
    getVendorsList: function () {
      let payload = {
        tableName: "ms_unit_of_measurement",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_unit_of_measurement = data.Records;
            this.ms_unit_of_measurement.map((x) => {
              if (this.uom_id == x.uom_id) {
                this.uom_unit = x.uom_unit;
                this.uom_parent_id = x.uom_parent_id;
                this.uom_formula = x.uom_formula;
                this.uom_description = x.uom_description;
                this.uom_is_active = x.uom_is_active;
                this.created_at = x.created_at;
                this.updated_at = x.updated_at;
                //   this.fc_icon_url = x.fc_icon_url;
                this.getViewUsersDetails(x.created_by, "created_by");
                this.getViewUsersDetails(x.updated_by, "updated_by");
              }
              this.ms_unit_of_measurement.map((y) => {
                if (this.uom_parent_id > 0 && this.uom_parent_id == y.uom_id) {
                  this.is_parent = true;
                  this.fc_parent_label = y.uom_unit;
                }
              });
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getViewUsersDetails(user_id, fieldvalue) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[fieldvalue] = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/UnitofMesurementComponents/viewUnitOfMeasurement.vue